import CAAA1012RequestModel from '@/api/data/CAA/CAAA1012/CAAA1012RequestModel'
import CAAA1012ResponseModel from '@/api/data/CAA/CAAA1012/CAAA1012ResponseModel'
import ApiUrlConstants from '@/common/ApiUrlConstants'
import RestService from '@/common/RestService'

/**
 * ログインサービス
 */
export default class CAAG1120Service {
  private caaa1012RequestModel = new CAAA1012RequestModel()

  /**
   * CAAA1012 API処理呼出
   * @returns Object
   */
  public async callAPICAAA1012(): Promise<CAAA1012ResponseModel> {
    const caaa1012ResponseModel: CAAA1012ResponseModel = <
      CAAA1012ResponseModel
    > await RestService.post(ApiUrlConstants.CAAA1012, this.caaa1012RequestModel)

    return caaa1012ResponseModel
  }
}
